import {
  FORGOT_LOGIN,
  forgotLoginSuccess,
  forgotLoginFailed,
} from "../actions";
import { ofType } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { from, of } from "rxjs";
import GolferApi from "../../../services/golfer-api";

export default (action$) =>
  action$
    .pipe(ofType(FORGOT_LOGIN))
    .pipe(switchMap(({ payload }) => action(payload)));

const action = (payload) =>
  from(GolferApi.forgotLogin(payload))
    .pipe(map((response) => forgotLoginSuccess(response.data)))
    .pipe(catchError((error) => of(forgotLoginFailed(error.response?.data))));
